<template>
  <transition-group tag="ul" :name="transition" class="row">
    <li v-for="post in feed" class="preview col-md-4" :key="post.id">
      <figure class="preview__figure" :class="[figureClass, post.image]">
        <transition name="v--fade">
          <figcaption v-if="!reading || $device.phone" class="preview__details">
            <router-link
              class="preview__title"
              :to="`/read/${post.id}`"
              @click.native="scrollToTop"
            >
              <div>
                <div class="top">{{ post.title }}</div>
                <div class="bottom">{{ post.subTitle }}</div>
              </div>
            </router-link>

            <div class="preview__meta">
              <time class="preview__published">{{ prettyDate(post.published) }}</time>

              <router-link
                class="preview__author"
                :to="`/home/team`"
                @click.native="scrollTo(0, 220, scrollDelay)"
              >{{ post.author }}</router-link>
            </div>
          </figcaption>
        </transition>
      </figure>
    </li>
  </transition-group>
</template>

<script>
import { scrollTo, kebabify, prettyDate } from "../helpers";

export default {
  name: "blog-feed",
  resource: "BlogFeed",

  props: {
    filters: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      posts: [],
      dataPosts: [
        {
          title: "Zoom临场体验育儿辅导文字总结： 如何提供孩子的专注力",
          subTitle: "第一篇： 咨询前期，心理师为什么要问一堆不着边际的问题？",
          image: "front_1",
          published: "2021-03-13T18:17:00Z",
          author: "Yi Zhang",
          id: "zoom-attention-span-part1"
        },
        {
          title: "Zoom临场体验育儿辅导文字总结： 如何提供孩子的专注力",
          subTitle: "第二篇：如何扩展孩子的专注力 - 给予情感和行为上的支持",
          image: "front_2",
          published: "2021-03-13T18:17:00Z",
          author: "Yi Zhang",
          id: "zoom-attention-span-part2"
        },
        {
          title: "Zoom临场体验育儿辅导文字总结： 如何提供孩子的专注力",
          subTitle: "第三篇： 如何扩展孩子的专注力 - 满足孩子的感官需求是关键",
          image: "front_3",
          published: "2021-03-13T18:17:00Z",
          author: "Yi Zhang",
          id: "zoom-attention-span-part3"
        },
        {
          title: "Zoom临场体验育儿辅导文字总结： 如何提供孩子的专注力",
          subTitle: "第四篇： 观众问题回答",
          image: "front_4",
          published: "2021-03-13T18:17:00Z",
          author: "Yi Zhang",
          id: "zoom-attention-span-part4"
        },
        {
          title: "如何成为一个坚强的人：心理韧性强大人群的三个秘密",
          image: "resilience",
          published: "2021-02-26T18:17:00Z",
          author: "Yi Zhang",
          id: "resilience"
        },
        {
          title: "钢琴与我的缘分",
          image: "pianoImage",
          published: "2020-05-04T18:17:00Z",
          author: "Yi Zhang",
          id: "piano"
        },
        {
          title: "儿童青少年性教育",
          image: "sexEdImage",
          published: "2020-02-13T18:17:00Z",
          author: "Yi Zhang",
          id: "sex-ed"
        }
      ],
      transition: "preview-appear"
    };
  },

  //

  computed: {
    reading() {
      return this.filters.post;
    },
    scrollDelay() {
      return this.$device.phone ? 0 : 560;
    },
    figureClass() {
      return { "preview__figure--mobile": this.$device.phone && this.reading };
    },
    feed() {
      const filterBy = {
        post: (filter, { id }) => filter === id,
        author: (filter, { author }) => filter === this.kebabify(author)
      };

      if (!Object.keys(this.filters).length) return this.posts;

      return this.posts.filter(post => {
        return Object.keys(this.filters).every(filter => {
          return filterBy[filter](this.filters[filter], post);
        });
      });
    }
  },

  methods: {
    scrollTo,
    kebabify,
    prettyDate,
    getBgImg(src) {
      return {
        backgroundImage: `url(${src})`
      };
    },
    stackPosts(posts) {
      let interval;
      const stack = () => {
        this.posts.push(posts.shift());

        if (!posts.length) {
          this.transition = "preview";
          clearInterval(interval);
        }
      };

      interval = setInterval(stack, 125);
    },
    scrollToTop() {
      window.scrollTo(0,0);
    }
  },

  mounted() {
    if (!Object.keys(this.filters).length) {
      this.stackPosts(this.dataPosts);
    } else {
      this.posts = posts;
      this.transition = "preview";
    }
  }
};
</script>
<style src='../assets/css/feed-images.css'></style>
<style>
.top {
  top: 0;
  font-size: 45px;
}
.bottom {
  position: absolute;
  bottom: 0;
  font-size: 40px;
}
</style>
